import { generateItems } from 'domain/common';
import { Alert } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Alert', Alert);

export { actions, selectors, reducer };
